let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("eufZR"), load("iLgOr"), load("dLkMK"), load("klDll")]).then(() => parcelRequire('D7PHQ'));